import { useState, useEffect } from 'react';

// Custom hook for API calls
const useApi = (apiFunction, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiFunction();
        
        // Handle the new response format
        if (response.data && response.data.success === true) {
          setData(response.data.data || response.data);
        } else {
          throw new Error(response.data?.message || 'An error occurred');
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps

  const refetch = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiFunction();
      
      // Handle the new response format
      if (response.data && response.data.success === true) {
        setData(response.data.data || response.data);
      } else {
        throw new Error(response.data?.message || 'An error occurred');
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refetch };
};

export default useApi;